import { ResolveFn } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { map } from 'rxjs';

export const storyblokPageBackgroundColorResolver: (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolver: any
) => ResolveFn<unknown> = resolver => route => {
  return resolver(route).pipe(
    map((story: ISbStoryData) => {
      if (!story) return;
      const raw = story.content?.themeColor;
      return typeof raw === 'string' && raw.trim() ? raw.trim() : '';
    })
  );
};
